// src-dev/ts/main.ts

import { initHeroSlider } from './sections/hero';
import { initMenu } from './components/menu';
import { initGallerySlider } from './components/gallery-slider';
import { initClientsCarousel } from './components/carousel';
import { initScrollAnimations } from './components/scroll-animations';

document.addEventListener('DOMContentLoaded', () => {
  initHeroSlider();
  initMenu();
  initGallerySlider();
  initClientsCarousel();
  initScrollAnimations();
});